import { HttpContextToken } from '@angular/common/http'

export const SUPPRESS_GLOBAL_ERROR_ALERT = new HttpContextToken<boolean>(() => false)
